var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnimeWatchHistoryRecommender',{attrs:{"userWatchHistory":_vm.userWatchHistory,"specificity":_vm.specificity}})}
var staticRenderFns = []

export { render, staticRenderFns }